import listActions from 'src/modules/turnoLaboral/list/turnoLaboralListActions';
import TurnoLaboralService from 'src/modules/turnoLaboral/turnoLaboralService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'TURNOLABORAL_DESTROY';

const turnoLaboralDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: turnoLaboralDestroyActions.DESTROY_STARTED,
      });

      await TurnoLaboralService.destroyAll([id]);

      dispatch({
        type: turnoLaboralDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.turnoLaboral.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/turno-laboral');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: turnoLaboralDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: turnoLaboralDestroyActions.DESTROY_ALL_STARTED,
      });

      await TurnoLaboralService.destroyAll(ids);

      dispatch({
        type: turnoLaboralDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.turnoLaboral.destroyAll.success'),
      );

      getHistory().push('/turno-laboral');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: turnoLaboralDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default turnoLaboralDestroyActions;
